export interface BackgroundCheckTest {
    useTestData: boolean;
    testData: {
        SUPERVAL: 'CLEAN' | 'DIRTY';
        SSNVER: 'CLEAN' | 'DIRTY';
        NWSEXVAL: 'CLEAN' | 'DIRTY';
        OFAC: 'CLEAN' | 'DIRTY';
    };
    jnetReturnCode: number;
}

const testDataValues = [
    { value: 'CLEAN', label: 'CLEAN' },
    { value: 'DIRTY', label: 'DIRTY' },
];

export const backgroundCheckTestForm = {
    type: 'form',
    children: [
        {
            type: 'form.checkbox',
            key: 'useTestData',
            label: 'Use Test Data',
        },
        {
            type: 'form.radio',
            key: 'testData.SUPERVAL',
            label: 'SUPERVAL',
            values: testDataValues,
        },
        {
            type: 'form.radio',
            key: 'testData.SSNVER',
            label: 'SSNVER',
            values: testDataValues,
        },
        {
            type: 'form.radio',
            key: 'testData.NWSEXVAL',
            label: 'NWSEXVAL',
            values: testDataValues,
        },
        {
            type: 'form.radio',
            key: 'testData.OFAC',
            label: 'OFAC',
            values: testDataValues,
        },
        {
            type: 'form.select',
            key: 'jnetReturnCode',
            label: 'JNET test data. Return codes:',
            values: [
                { label: '0: Success', value: 0 },
                { label: '1: XML Unable to Load', value: 1 },
                { label: '2: Access Token Incorrect', value: 2 },
                { label: '3: Error While Validating Access Token', value: 3 },
                { label: '4: Error Reading XML', value: 4 },
                { label: '5: Error Inserting Data Into Database', value: 5 },
                { label: '6: Wrong Request Format', value: 6 },
            ],
        },
    ],
};

export const defaultBackgroundCheckTest: BackgroundCheckTest = {
    useTestData: true,
    testData: {
        SUPERVAL: 'DIRTY',
        SSNVER: 'DIRTY',
        NWSEXVAL: 'DIRTY',
        OFAC: 'DIRTY',
    },
    jnetReturnCode: 0,
};
